import { render, staticRenderFns } from "./LanguageAdaptiveSelect.vue?vue&type=template&id=a4e5da6a&"
import script from "./LanguageAdaptiveSelect.vue?vue&type=script&lang=js&"
export * from "./LanguageAdaptiveSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports